import React, { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import { useObserver } from 'mobx-react-lite';
import { useStores } from '../../../store';
import { DownloadResume } from '../resume_output'; // Assuming this is the correct import path

const Resume19 = () => {
  const { ResumeStore } = useStores();
  const resumeRef = useRef(null);

  const handleDownload = useReactToPrint({
    content: () => resumeRef.current,
  });

  return useObserver(() => (
    <>
      <DownloadResume onClick={handleDownload} />
      <div className="flex w-full my-5 mx-auto bg-white shadow-lg p-5 box-border" ref={resumeRef}>
        <div className="w-2/3 pr-5 border-r-2 border-gray-200">
          <div className="mb-5">
            <h1 className="text-4xl font-bold">
              Hello, I’m <span className="block">{ResumeStore?.resumeBuilder.personalDetails.firstName} {ResumeStore?.resumeBuilder.personalDetails.lastName}</span>
            </h1>
            <h2 className="text-lg font-medium mt-1 text-gray-600">{ResumeStore?.resumeBuilder.personalDetails.jobTitle}</h2>
            <p className="mt-5 text-sm text-gray-500">{ResumeStore?.resumeBuilder.profileSummary}</p>
          </div>
          <div className="mt-8">
            <h2 className="text-lg font-bold border-b-2 border-gray-200 pb-2 mb-5">Experience</h2>
            {ResumeStore?.resumeBuilder.employementHistory.map((job, index) => (
              <div key={index} className="mb-5">
                <h3 className="text-lg font-medium">{job.jobTitle}</h3>
                <p className="text-sm">{job.company}, {job.city}</p>
                <p className="text-sm text-gray-500">{job.description}</p>
                <p className="text-xs text-gray-400 mt-1">{job.startDate} - {job.endDate}</p>
              </div>
            ))}
          </div>
          <div className="mb-5">
            <h2 className="text-lg font-bold border-b-2 border-gray-200 pb-2 mb-3">Languages</h2>
            {ResumeStore?.resumeBuilder.languages.map((language, index) => (
              <p key={index} className="text-sm mb-2">{language.language} - {language.level}</p>
            ))}
          </div>
        </div>
        <div className="w-1/3 pl-5">
          <div className="mb-5">
            <h2 className="text-lg font-bold border-b-2 border-gray-900 pb-2 mb-3">Contact</h2>
            <p className="text-sm mb-2">{ResumeStore?.resumeBuilder.personalDetails.email}</p>
            <p className="text-sm mb-2">{ResumeStore?.resumeBuilder.personalDetails.phone}</p>
            <p className="text-sm mb-2">www.uxfolio.io/{ResumeStore?.resumeBuilder.personalDetails.firstName.toLowerCase()}</p>
            <p className="text-sm">{ResumeStore?.resumeBuilder.personalDetails.city}, {ResumeStore?.resumeBuilder.personalDetails.country}</p>
          </div>
          <div className="mb-5">
            <h2 className="text-lg font-bold border-b-2 border-gray-900 pb-2 mb-3">Education</h2>
            {ResumeStore?.resumeBuilder.education.map((edu, index) => (
              <div key={index} className="mb-5">
                <p className="text-sm">{edu.degree}<br />{edu.school}<br />{edu.startDate}</p>
              </div>
            ))}
          </div>
          <div className="mb-5">
            <h2 className="text-lg font-bold border-b-2 border-gray-900 pb-2 mb-3">Skills</h2>
            {ResumeStore?.resumeBuilder.skills.map((skill, index) => (
              <p key={index} className="text-sm mb-2">{skill}</p>
            ))}
          </div>
          <div className="mb-5">
            <h2 className="text-lg font-bold border-b-2 border-gray-900 pb-2 mb-3">Awards</h2>
            {ResumeStore?.resumeBuilder.extraCurricularActivities.map((item, index) => (
              <p key={index} className="text-sm mb-2">{item.functionTitle}</p>
            ))}
          </div>
        </div>
      </div>
    </>
  ));
}

export default Resume19;
